import { CSSObject } from '@emotion/react'
import { Size, Theme, ZIndex } from '@opallabs/gem'
import { variantStyles } from '../ButtonVariant/useVariantStyle'
import { Variants } from '../ButtonVariant/variants'

export const toggleButtonContainer = {
  display: 'inline-flex',
  flexDirection: 'row',
  flexShrink: 1,
  flexWrap: 'nowrap',
  borderRadius: Size.Rounding,
  borderWidth: 1,
  borderStyle: 'solid',
} satisfies CSSObject

export const toggleButtonContainerVariant = (theme: Theme, variant: Variants) =>
  ({
    ...variantStyles(theme, variant),
  }) satisfies CSSObject

export const toggleButton = {
  borderStyle: 'solid',
  borderColor: 'transparent',

  // The buttons sit edge to edge, so a ring on one runs under the next, which
  // is painted after it. The focused button comes to the front for its ring.
  '&:focus-visible': {
    position: 'relative',
    zIndex: ZIndex.Element.Level1,
  },
} satisfies CSSObject
